import { Component, OnInit, ViewChild } from '@angular/core';
import { Badge } from 'src/app/entity/badge';
import { VisiteurServiceService } from 'src/app/service/visiteur.service';
import { BadgeServiceService } from 'src/app/service/badge.service';
import { ComposeMailComponent } from '../../email/include/compose-mail/compose-mail.component';
import { MailsService } from 'src/app/service/mails.service';
import { Contact } from 'src/app/entity/Contact';

@Component({
  selector: 'app-badges-exposant',
  templateUrl: './badges-exposant.component.html',
  styleUrls: ['./badges-exposant.component.css']
})
export class BadgesExposantComponent implements OnInit {
  visiteurs: Badge[];
  selectedBadge:Badge;
  @ViewChild(ComposeMailComponent )
  private composeMailComponent: ComposeMailComponent;
  cols: any[];
  uploadedFiles: any[];
  constructor(private badgeServiceService:BadgeServiceService,private mailsService:MailsService ) {
    this.cols = [
      { field: 'nom', header: 'Nom' },
 
      { field: 'fonction', header: 'Position' },
 
      { field: 'company', header: 'Company' },

      { field: 'mail', header: 'Email' },
      { field: 'mobile', header: 'Mobile' },
      { field: 'dateImpression', header: 'Date impression' },

/*
    private String nom;
    private String mobile;
    private String mail;
    private String fonction;
    private String typebadge;
*/
/*
name: string;
    lastName: string;
    position: string;

    activitySector: string;

    companyName: string;
    adress: string;
    typed: string;
    email: string;
    mobile: string;
    web: string;
    rejete: string;

    motifRejet: string;

    dateEnre: string;

    dateImpression: string;

*/


  ];
   }
   printBadge() {
    this.badgeServiceService.print(this.selectedBadge,'e').subscribe(
      (res: any) => {

        var filename = 'restfile.pdf';

        filename = filename.replace(/[/\\?%*:|"<>]/g, '-');
        var fileURL = URL.createObjectURL(res);
        window.open(fileURL);

      }


    )
  }
   sendEBAdge(nbr: number) {
 

    this.uploadedFiles = []
    this.badgeServiceService.print(this.selectedBadge,'e').subscribe(
      (res) => {
        var filename = this.selectedBadge.nom + 'badge.pdf';

        filename = filename.replace(/[/\\?%*:|"<>]/g, '');
        res.name = filename;
        this.uploadedFiles.push(res);

let contact=new Contact();
contact.mail=this.selectedBadge.mail;
        this.mailsService.findodel(nbr).subscribe(result => {
//  prepareEmailModel(modelCores: Modelcores, contact: Contact, projet: string, prospect: Prospect, uploadedFiles: any[])
          this.composeMailComponent.prepareEmailModel(result, contact,'',null, this.uploadedFiles)
        })

      }
    );

  }

  ngOnInit() {
    //console.log('getall');
    
    this.badgeServiceService.getAll().subscribe(
      result=>{
        this.visiteurs=result;
        
        
      }
    )
  }

}
